<template>
	<div class="administrative-costs">
		<v-layout row wrap>
			<v-flex d-flex xs12>
				<v-card color="grey">
					<v-card-text>
						<h2>
							Koszty administracyjne
							<egranty-icon-button
								v-if="!readonly"
								@click="addAdministrative"
								icon="add_circle"
								color="primary"
								label="Dodaj nowy koszt"
								for="administrative-add-new-cost-button"
								id="administrative-add-new-cost-button"
							></egranty-icon-button>
						</h2>

					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<div
			v-for="(cost, index) in administrative"
			:key="index"
		>
			<v-layout row wrap>
				<v-flex d-flex>
					<v-card color="grey lighten-3">
						<v-card-text>
							{{cost.serialNumber}}
						</v-card-text>
						<egranty-icon-button
							class="up-button"
							v-if="!readonly"
							@click="moveAdministrativeUp(index)"
							icon="arrow_drop_up"
							color="primary"
							label="Przesuń w górę"
							for="administrative-move-up-this-cost"
							id="administrative-move-up-this-cost"
						></egranty-icon-button>
						<egranty-icon-button
							class="down-button"
							v-if="!readonly"
							@click="moveAdministrativeDown(index)"
							icon="arrow_drop_down"
							color="primary"
							label="Przesuń w dół"
							for="administrative-move-down-this-cost"
							id="administrative-move-down-this-cost"
						></egranty-icon-button>
						<egranty-icon-button
							v-if="!readonly && isLastCost(index)"
							@click="addAdministrative"
							icon="add_circle"
							color="primary"
							label="Dodaj nowy koszt"
							class="bottom-button"
							small
							for="administrative-add-new-cost-button-bottom"
							id="administrative-add-new-cost-button-bottom"
						></egranty-icon-button>
					</v-card>
				</v-flex>
				<v-flex d-flex xs4>
					<v-card color="grey lighten-3">
						<v-card-text>
							<costs-text-input-field
								:disabled="readonly"
								class="administrative-cost-name"
								label="Nazwa kosztu"
								for="administrative-add-new-cost"
								id="administrative-add-new-cost"
								v-model="cost.name"
								@input="sync"
							></costs-text-input-field>
							<div class="administrative-costs-delete">
								<egranty-icon-button
									v-if="!readonly"
									@click="deleteAdministrative(index)"
									icon="delete"
									color="lightred"
									label="Usuń ten koszt"
									for="administrative-delete-this-cost"
									id="administrative-delete-this-cost"
								></egranty-icon-button>
							</div>
						</v-card-text>
					</v-card>
				</v-flex>

				<v-flex d-flex xs2>
					<v-card color="grey lighten-3">
						<v-card-text>
							<costs-text-input-field
								:disabled="readonly"
								class="administrative-costs-measure-name"
								label="Nazwa miary"
								for="administrative-name-measure"
								id="administrative-name-measure"
								v-model="cost.measureType"
								@input="sync"
							></costs-text-input-field>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-3">
						<v-card-text>
							<egranty-number-input-field
								:disabled="readonly"
								class="administrative-costs-unit-cost"
								label="Koszt jednostkowy"
								for="administrative-unit-cost"
								id="administrative-unit-cost"
								v-model="cost.pricePerUnit"
								@input="updateCalculatedAndSync"
							></egranty-number-input-field>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-3">
						<v-card-text>
							<egranty-number-input-field
								:disabled="readonly"
								class="administrative-costs-number-units"
								v-model="cost.unitsCount"
								label="Liczba jednostek"
								for="administrative-number-unit"
								id="administrative-number-unit"
								@input="updateCalculatedAndSync"
							></egranty-number-input-field>
						</v-card-text>
					</v-card>
				</v-flex>
				
				<v-flex d-flex xs2>
					<v-card color="grey lighten-3" class="d-flex justify-center align-center">
						<v-card-text>
							<div>
								Źródło finansowania
							</div>
					
							
							<egranty-icon-button
								v-if="!isEdited(index) && !readonly"
								@click="startEdit(index)"
								icon="edit"
								label="Edytuj"
								for="administrative-edit"
								id="administrative-edit"
							></egranty-icon-button>

							<egranty-icon-button
								v-if="isEdited(index) && !readonly"
								@click="editing = false"
								icon="done_outline"
								label="Zakończ edycję"
								for="administrative-end-edition"
								id="administrative-end-edition"
							></egranty-icon-button>

							<egranty-icon-button
								v-if="isEdited(index) && !readonly"
								@click='addCostDivision(cost)'
								icon="add_circle"
								label="Dodaj kolejne źródło finansowania"
								for="administrative-add-next-cost-division"
								id="administrative-add-next-cost-division"
							></egranty-icon-button>
							<div v-if="cost.costDivisions.length < 2">
								{{cost.costDivisions[0].type}}
							</div>

						</v-card-text>

					</v-card>
				</v-flex>

				<v-flex d-flex xs1>
					<v-card color="grey lighten-3" class="d-flex justify-center align-center">
						<v-card-text>
							<strong>
								{{formatMoney(administrativeTotal[index])}}<br>
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
			<div v-if="cost.costDivisions.length > 1">
				<div
					v-for="(division, divisionIndex) in cost.costDivisions"
					:key="divisionIndex"
				>
					<v-layout row wrap
						v-if="divisionIndex !== 0 || isEdited(index) || division.totalPrice > 0.001"
					>
						<v-flex d-flex xs9>
							<v-card color="grey lighten-3">
							</v-card>
						</v-flex>

						<v-flex d-flex xs2>
							<v-card color="grey lighten-3" class="d-flex justify-center align-center">
								<v-card-text>
									<egranty-icon-button
										v-if="isEdited(index) && !readonly && divisionIndex !== 0"
										@click="deleteCostDivision(cost, divisionIndex)"
										label="Usuń źródło finansowania"
										color="lightred"
										icon="delete"
									></egranty-icon-button>
									<v-select
										aria-label="division type"
										v-if="isEdited(index) && divisionIndex !== 0"
										style="padding: 0"
										v-model="division.type"
										:items='options'
										@input="sync"
									></v-select>
									<div v-if="!isEdited(index) || divisionIndex === 0">
										{{division.type}}
									</div>
								</v-card-text>
							</v-card>
						</v-flex>

						<v-flex d-flex xs1>
							<v-card color="grey lighten-3" class="d-flex justify-center align-center">
								<v-card-text>
									<egranty-number-input-field
										:disabled="readonly"
										v-if='isEdited(index) && divisionIndex !== 0'
										label="kwota"
										for="administrative-amount"
										id="administrative-amount"
										v-model="cost.costDivisions[divisionIndex].totalPrice"
										@input="updateCalculatedAndSync"
									></egranty-number-input-field>
									<div v-else>
										{{formatMoney(cost.costDivisions[divisionIndex].totalPrice)}}
									</div>
								</v-card-text>
							</v-card>
						</v-flex>
					</v-layout>
				</div>
			</div>
			<egranty-validation-error
				v-for="error in cost.errors"
				:key="error"
				:error=error
			></egranty-validation-error>
		</div>
	</div>
</template>
<script>
	import CostsTextInputField from "../CostsTextInputField";
	import EgrantyIconButton from "../../../../../genericComponents/EgrantyIconButton";
	import EgrantyValidationError from "../../../../../genericComponents/EgrantyValidationError";
	import EgrantyNumberInputField from "../../../../../genericComponents/EgrantyNumberInputField";
	import {Numbers} from "@/utils/Numbers";

	export default {
		name: "Administrative",

		components: {EgrantyValidationError, EgrantyIconButton, EgrantyNumberInputField, CostsTextInputField},

		props: {
			readonly: {default: false},
			addAdministrative: {},
			addCostDivision: {},
			deleteCostDivision: {},
			administrative: {},
			administrativeTotal: {},
      deleteAdministrative: {},
      moveAdministrativeUp: {},
      moveAdministrativeDown: {},
			options: {},
			sync: {type: Function},
			updateCalculated: {},
		},

		mixins: [Numbers],

		created() {
			if (this.administrative.length < 1) {
				this.addAdministrative();
			}
		},

		methods: {
			updateCalculatedAndSync() {
				this.updateCalculated();
				this.sync();
			},

			startEdit(index) {
				this.editing = true;
				this.editedIndex = index;
			},

			isEdited(index) {
				return this.editing && this.editedIndex === index;
			},

			isLastCost(index) {
				return index === (this.administrative.length - 1);
			}
		},

		data() {
			return {
				editing: false,
				editedIndex: "",
			};
		},
	};
</script>

<style>
	.administrative-costs-measure-name .v-label,
	.administrative-costs-unit-cost .v-label,
	.administrative-costs-number-units .v-label {
		font-size: 13px;
		overflow: visible;
		max-width: 70px;
	}

	.administrative-costs-delete .v-btn--icon {
		position: absolute;
		top: 30px;
		right: 10px;
	}

	.administrative-costs .administrative-costs-measure-name textarea {
		padding-left: 0;
		padding-right: 0;
	}

	.administrative-costs .v-card {
		width: 100% !important;
	}


	.theme--dark .administrative-costs .grey.lighten-3 {
		background-color: #1B1B1B !important;
	}

	.theme--dark .grey.lighten-3 {
		background-color: #1b1B1B !important;
	}

	.theme--dark .grey.lighten-4 {
		background-color: #1B1B1B !important;
	}

	.application.mediumFont .v-input .v-label {
		font-size: 1.1em;
	}

	/* .application.largeFont .v-input .v-label {
		font-size: 1.1em;
	} */

	.theme--dark .green.lighten-2 {
		background-color: #237626 !important;
	}

	.v-stepper__items .v-card__text {
		padding: 10px 7px 7px;
	}


	.source-finance-text {
		width: 100%;
		border-bottom: solid 1px rgba(0,0,0,0.50);
	
	}

	.source-finance-text strong {
		color: rgba(0,0,0,0.50);
	}

    .v-textarea textarea {
       max-width: 99%;
    }

	.theme--dark .source-finance-text {
		border-bottom: solid 1px #fff;

	}

	.theme--dark .source-finance-text strong {
		color: #fff;
	}

	.bottom-button {
		position: relative;
		bottom: 0;
		margin-left: 40px;
	}

  .up-button {
    position: relative;
    bottom: 0;
    left: 0;
  }

  .down-button {
    position: relative;
    bottom: 0;
    left: 0;
  }
</style>

